module.exports = __webpack_public_path__ + "img/home.2f8c0b5a.svg";